export const SHOW_NOTIFICATION = "notification/show_notification"
export const SET_NOTIFICATION = "notification/set_notification"
